import type { ShapeData } from '@/lib/shapes/types/shape-data'
import { buildShapeClikArtFill } from '@/lib/clikart/build-clikart-shape-fill'
import { buildPlacedFillShape } from '@/lib/photos/build-placed-fill-shape'
import type { BuildPlacedClikArtShapeInput } from './types/build-placed-clik-art-shape-input'

/**
 * A ClikArt dropped directly onto the canvas (not onto an existing shape) creates a real
 * borderless rectangle sized to the art, with the art as its `photoFill` — the ClikArt-side
 * counterpart of `lib/photos/build-placed-photo-shape.ts`'s `buildPlacedPhotoShape`, sharing
 * `buildPlacedFillShape` for the geometry.
 */
export function buildPlacedClikArtShape({
  item,
  ...input
}: BuildPlacedClikArtShapeInput): ShapeData {
  return buildPlacedFillShape({
    ...input,
    buildFill: (naturalSize) => buildShapeClikArtFill(item, naturalSize),
  })
}
